import type * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import type { BadgeOrigin } from './badgeposition';
import { DotBadge } from './DotBadge/DotBadge';

export type BadgeTypes = {
  /**
   * anchor Origin props for badge
   */
  anchorOrigin?: BadgeOrigin;
  /**
   * The content rendered within the badge.
   */
  badgeContent?: React.ReactNode;
  /**
   * The badge will be added relative to this node.
   */
  children?: React.ReactNode;
  /**
   * The color variants for the badge
   */
  color?: 'default' | 'error' | 'gray' | 'primary' | 'secondary';
  /**
   * If `true`, the badge will be invisible.
   */
  invisible?: boolean;
  /**
   * Max count to show.
   */
  max?: number;
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   */
  showZero?: boolean;
  /**
   * Size of the badge
   */
  size?: 'medium' | 'small';
  /**
   * The type of the badge
   */
  variant: 'dot' | 'standard';
};

const BadgeContainer = styled.div`
  ${tw`relative flex-shrink-0`}
`;

export const Badge: React.FunctionComponent<BadgeTypes> = ({
  anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
  badgeContent,
  children,
  color = 'error',
  max = 99,
  showZero = false,
  size,
  variant,
  invisible,
}: BadgeTypes) => {
  return (
    <BadgeContainer>
      {children}
      <DotBadge
        color={color}
        anchorOrigin={anchorOrigin}
        badgeContent={badgeContent}
        variant={variant}
        max={max}
        showZero={showZero}
        size={size}
        invisible={invisible}
      />
    </BadgeContainer>
  );
};
